import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { TurnOverHeading } from "../../../Constant";
import { TURN_OVER_CHART } from "../../../Data/Widgets/ChartWidgets";

const Turnover = () => {
  return (
    <Col xl="5" lg="12" className="xl-50">
      <Card>
        <CommonCardHeader title={TurnOverHeading} className="border-bottom-1"/>
        <CardBody>
          <div className="chart-container">
            <Row>
              <Col xs="12">
                <ReactApexChart options={TURN_OVER_CHART} series={TURN_OVER_CHART.series} type="area" id="chart-widget7" height={320} />
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Turnover;
